import React, { Component } from 'react';
import Layout from "./Layout";
import { Button } from "~/js/partials";
import { favouritesService } from '~/js/_services';
import Confirmation from "~/js/components/Confirmation";
import { CopyToClipboard } from 'react-copy-to-clipboard';

const confirmation = Confirmation.instance();

export default class ShareURLPopup extends Component {

    handleCopy = () => {
        confirmation.open({
            msg: 'Copied to clipboard'
        });
    };
    
    render() {
        const { close, shareTitle, ...rest } = this.props;
        const url = window.location.href;

        return (
            <Layout
                title={shareTitle}
                text={"Share the link below, click to copy to clipboard."}
                close={close}
                {...rest}
            >
                <CopyToClipboard 
                    text={url}
                    onCopy={this.handleCopy}
                    className='popup-form__share'
                >
                    <div>{url}</div>
                </CopyToClipboard>
            </Layout>
        );
    }
}